import React from 'react'
import {SpaceProto} from "../../../../core/model2/space/space-proto";

type Props = {
    space                   : SpaceProto,
    className?              : string
    children?               : any
}

export default function NavigationMenu_TopHeader(props: Props) {

    return (
        <div className={Classes("top-header flex-row-between-center", props.className)}>
            <div className="ui5-title-app-name p-l-20 no-wrap">
                {props.space.title}
            </div>

            {props.children &&
                <div className="left-nav-space-controls">
                    {props.children}
                </div>
            }

        </div>
    )
}
